import { AcademyConnectionWorkspaceDetailsFragment } from '@/modules/lyearn-connect/graphql/fragments/generated/AcademyConnectionWorkspaceDetails';
import { useAcademyRelatedConnectionQuery } from '@/modules/lyearn-connect/graphql/queries/generated/academyRelatedConnection';
import { RelatedConnectionsFilters } from '@/types/schema';

interface Props {
  filters: RelatedConnectionsFilters;
  pause?: boolean;
}

const useAcademyRelatedConnections = ({ filters, pause }: Props) => {
  const [{ fetching, error, data }] = useAcademyRelatedConnectionQuery({
    variables: { filters },
    pause,
  });

  return {
    fetching,
    error,
    connections: (data?.relatedConnections?.workspaceDetails ??
      []) as AcademyConnectionWorkspaceDetailsFragment[],
  };
};

export default useAcademyRelatedConnections;
